import classNames from 'classnames';
import { MarketStatusPill } from '~/features/shared/market-content';
import { LISTING_FILLED_LABEL, LISTING_FILLED_NOTE } from '../utils';

// [MCV-1889] Shown in place of the actions on a response closed because its listing filled.
export const ListingFilledNotice = ({ className }: { className?: string }) => (
  // #root centers text, so the note says it is left-aligned wherever it is dropped in.
  <div className={classNames('text-left', className)} data-cy="b2b-listing-filled-notice">
    <MarketStatusPill status="neutral" label={LISTING_FILLED_LABEL} size="md" />
    <p className="mt-2 text-sm text-content-secondary">{LISTING_FILLED_NOTE}</p>
  </div>
);
